import { CloudObject } from 'olympe';

/**
 * Find an object property based on its name
 * @param {!CloudObject} object
 * @param {string} path
 * @return {!PropertyModel}
 */
export function findObjectProperty(object, path) {
    const mapping = getModelPropertiesMapping(object);
    return mapping.get(path);
}

/**
 * Get all properties name of an object
 * @param {!CloudObject} object
 * @return {!Array<string>}
 */
export function getModelPropertiesName(object) {
    const mapping = getModelPropertiesMapping(object);
    return Array.from(mapping.keys());
}

/**
 * Get an object model properties mapping
 * @param {!CloudObject} object
 * @return {!Map<string, PropertyModel>}
 */
function getModelPropertiesMapping(object) {
    const model = object.getModel();
    if(!modelProperties.has(model.getTag())) {
        const mapping = new Map();
        model.query()
            .follow(CloudObject.propertyRel)
            .executeFromCache()
            .forEach(property => mapping.set(property.name(), property));
        modelProperties.set(model.getTag(), mapping);
    }
    return modelProperties.get(model.getTag());
}

/**
 * Singleton map for model properties mapping (name <-> instance)
 * @type {!Map<string, !Map<string, PropertyModel>>}
 */
const modelProperties = new Map();

